
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import classes from './PlayerBlock.module.css';
import AppState from '@/js/AppState';

const PlayerBlock = () => {

  const pseudo = "Joueur" // AppState.vertxClient.UserData.getPseudo()
  const group = "Démo" //AppState.group.teamPseudo
  
  return (
    <div className={classes.PlayerBlock}>
      <div className={classes.GroupName}>{group}</div>
      <div className={classes.PlayerName}>{pseudo}</div>
    </div>
  );
};

export default observer(PlayerBlock);
